import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ScrollspyDirective } from './scrollspy.directive';
import { CarouselModule } from 'ngx-owl-carousel-o';
import { CountToModule } from 'angular-count-to';
import { ScrollToModule } from '@nicky-lenaers/ngx-scroll-to';
import { AboutComponent } from './about/about.component';
import { ClientsComponent } from './clients/clients.component';
import { ContactComponent } from './contact/contact.component';
import { FeaturesComponent } from './features/features.component';
import { FooterComponent } from './footer/footer.component';
import { ServicesComponent } from './services/services.component';
import { ProjectsComponent } from './projects/projects.component';
import { HeaderComponent } from './header/header.component';
import { BannerComponent } from './banner/banner.component';
import { FormsModule } from '@angular/forms';



import { RouterModule } from '@angular/router';
import { HomeComponent } from './home/home.component';
import { PoliticasPrivacidadRentascrComponent } from './politicas-privacidad-rentascr/politicas-privacidad-rentascr.component';
import { DeleteDataRentascrComponent } from './delete-data-rentascr/delete-data-rentascr.component';

@NgModule({
  declarations: [
    AboutComponent, 
    ClientsComponent, 
    ContactComponent, 
    FeaturesComponent, 
    FooterComponent, 
    ServicesComponent, 
    ScrollspyDirective, 
    ProjectsComponent, 
    HeaderComponent, 
    BannerComponent,
    HomeComponent,
    PoliticasPrivacidadRentascrComponent,
    DeleteDataRentascrComponent
  ],
  imports: [
    ScrollToModule.forRoot(),
    CommonModule, 
    CarouselModule, 
    CountToModule,
    FormsModule,
    RouterModule
  ],
  exports: [
    AboutComponent, 
    ClientsComponent, 
    ContactComponent, 
    FeaturesComponent, 
    FooterComponent, 
    ServicesComponent, 
    ScrollspyDirective,
    ProjectsComponent,
    HeaderComponent,
    BannerComponent,
    HomeComponent,
    PoliticasPrivacidadRentascrComponent,
    DeleteDataRentascrComponent
  ]
})
export class ComponentsModule { }
